var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgGallery(props) {
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M38.42 6.23c-.61-2.236-2.53-3.85-4.94-4.023-2.822-.203-6.996-.394-12.699-.394-5.668 0-9.825.188-12.646.39-2.823.201-4.982 2.359-5.183 5.183-.202 2.821-.39 6.979-.39 12.645 0 5.703.193 9.876.395 12.698.173 2.41 1.788 4.33 4.022 4.94",
    stroke: "url(#".concat(_id, ")"),
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.89 17.323c.202-2.824 2.36-4.98 5.184-5.182 2.82-.203 6.977-.391 12.645-.391 5.667 0 9.823.189 12.645.39 2.824.202 4.982 2.36 5.183 5.184.202 2.821.39 6.978.39 12.645s-.188 9.823-.39 12.646c-.201 2.823-2.359 4.98-5.183 5.182-2.822.202-6.979.39-12.645.39-5.668 0-9.824-.188-12.646-.39-2.824-.201-4.98-2.359-5.182-5.183-.203-2.82-.391-6.978-.391-12.645 0-5.668.189-9.824.39-12.646z",
    stroke: "url(#".concat(_id2, ")"),
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.767 38.68c-2.49-2.335-4.284-3.89-5.53-4.907-1.477-1.21-3.424-1.385-5.015-.324-1.226.817-2.909 2.065-5.107 3.952-3.269-3.126-5.521-5.09-6.998-6.3-1.478-1.208-3.425-1.383-5.017-.323-1.788 1.193-4.552 3.304-8.466 6.976",
    stroke: "url(#".concat(_id3, ")"),
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.583 22.792a3.312 3.312 0 106.625 0 3.312 3.312 0 00-6.625 0z",
    stroke: "url(#".concat(_id4, ")"),
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 14.529,
    y1: -4.54,
    x2: -3.6,
    y2: 23.993,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 24.661,
    y1: 5.295,
    x2: 6.237,
    y2: 34.29,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 24.693,
    y1: 28.555,
    x2: 23.272,
    y2: 37.948,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 36.794,
    y1: 18.306,
    x2: 33.445,
    y2: 23.578,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6700"
  })))));
}
export default SvgGallery;